import { ContentProps, EditorialFactoryProps } from "components/flexComponents/Editorial/typings";
import * as React from "react";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent,
  sendImmediateTrackEvent,
} from "components/utility/analytics/FlexAnalyticsUtils";
import { EditorialWithLink } from "components/flexComponents/Editorial/factory/impl/editorials/EditorialWithLink";
import EditorialBase from "components/flexComponents/Editorial/factory/EditorialBase";
import { getMABMicroMessage, MABPlatform, MABMicroMessage } from "src/components/utility/analytics/MABAnalyticsUtils";

export class CardWithLinkEditorial extends EditorialBase {
  constructor(editorial: EditorialFactoryProps) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const { analytics, compositionStore, context } = props;

    if (!this.editorial.items[0].media || this.editorial.items[0].media.length === 0) {
      return null;
    }

    const cardClicked = () => {
      const trackingInfo: FlexTrackingInfo = {
        moduleName: "editorial",
        rfrr: (this.editorial.title || "").replace(/\s/g, ""),
        action: Action.CLICK,
      };

      const banditContext = compositionStore?.composition?.bandit ?? null;

      if (banditContext && context?.deviceInformation) {
        const {
          deviceInformation,
          site: { id: pos },
        } = context;
        const { mobile, tablet } = deviceInformation;
        const cardLabel = this.editorial.items[0].title ?? "";
        const mabTrackingInfo: FlexTrackingInfo = {
          moduleName: "geo_hotels_2",
          rfrr: `editorial.${cardLabel.replace(/ /g, "_")}`,
          action: Action.CLICK,
        };

        const mabTrackingMessage: MABMicroMessage = getMABMicroMessage(
          banditContext,
          "geo_hotels_2",
          "homepageClick.path",
          mobile ? MABPlatform.Mobile : tablet ? MABPlatform.Tablet : MABPlatform.Desktop,
          pos
        );
        sendImmediateTrackEvent(mabTrackingInfo, analytics, mabTrackingMessage);
      }

      sendDelayedTrackEvent(trackingInfo, analytics);
    };

    const uitkClassNames = this.getEditorialItemClassName();

    return (
      <div
        id={this.id}
        data-fm={this.fmId}
        data-fm-title-id={this.fmTitleId}
        className={`uitk-cell uitk-type-center Editorial all-cell-1-1 ${uitkClassNames}`}
        onClick={cardClicked}
        role="button"
      >
        <EditorialWithLink model={this.editorial} />
      </div>
    );
  }

  public getEditorialItemClassName = (): string =>
    "all-t-margin-three m-b-margin-three l-b-margin-three xl-b-margin-three";
}

export default CardWithLinkEditorial;
